import Cookies from "universal-cookie";
import { Oval } from "react-loader-spinner";
import APIServices from "../services/APIServices";
import { countries } from "country-data";
export const PAGE_LIMIT = 10;
const cookies = new Cookies();

export const getCookies = (name) => {
  return cookies.get(name);
};

export const setCookies = (name, value, expiryAfterMinutes = 86400) => {
  let expire = new Date();
  //Application somehow unable to set cookie so storing token in sessionStorage and reading from same
  //sessionStorage.setItem(name,value)
  expire.setDate(expire.getDate() + expiryAfterMinutes);
  try {
    if (name === "adminToken")
      cookies.set(name, value, { expires: expire, path: "/", secure: true });
    else cookies.set(name, value, { expires: expire, path: "/" });
  } catch (err) {
    console.log(`Error setting cookie ${name} - value is ${value} --> ${err}`);
  }
};
export const userType = "owner";

export const emailLimit = 80;

export const userNameLimit = 40;

// Function to get the plain numeric phone number for API
export const getPlainPhoneNumber = (phoneNumber) => {
  let plainNumber = "";
  // Remove formatting from the phone number
  plainNumber = phoneNumber?.replace(/[^0-9]/g, "");
  return plainNumber;
};

export const formatSelectOptions = (
  data,
  valueKey = "_id",
  labelKey = "name"
) => {
  return data.map((item) => ({
    value: item[valueKey],
    label: item[labelKey],
  }));
};

export const getFileNameFromUrl = (url) => {
  // Extract the last part of the URL after the last '/'
  const filename = url.substring(url.lastIndexOf("/") + 1);

  // Optionally, remove any additional unwanted characters, like " - " if needed
  const cleanFilename = filename.split(" - ").pop();
  return cleanFilename;
};

export const selectLoader = (size = 20) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "10px",
    }}
  >
    <Oval
      height={size}
      width={size}
      color="#4fa94d"
      ariaLabel="oval-loading"
      wrapperStyle={{}}
      wrapperClass=""
    />
  </div>
);

export const fetchOptions = async (
  endpoint,
  setOptions,
  setLoading,
  setError,
  errorMsg
) => {
  try {
    const response = await APIServices.get(endpoint);
    const options = formatSelectOptions(
      response.blogCategories || response.blogTopics || []
    );
    setOptions(options);
    return options;
  } catch (err) {
    setError(errorMsg);
    console.error(errorMsg, err);
    return [];
  } finally {
    setLoading(false);
  }
};

export const removeNbsp = (html) => {
  // Replace all occurrences of &nbsp; with a regular space
  return html?.replace(/&nbsp;/g, " ");
};

// Basic Validation
export const validationFields = {
  title: "Title is required",
  description: "Description is required",
  // slug: "Slug is required",
  metaTitle: "Meta title is required",
  metaDesc: "Meta description is required",
  imageAltTag: "Image alt text is required",
  categoryId: "Category is required",
  topicIds: "Topic is required",
  authorName: "Author name is required",
  authorDesignation: "Author designation is required",
};

export const capitalizeFirstLetter = (status) => {
  return status.charAt(0).toUpperCase() + status.slice(1);
}

export const getformattedPhoneNumber = (value) => {
  const numericInput = value?.replace(/[^0-9]/g, "").slice(0, 14); // Limit to 14 digits

  // Format the phone number as (XXX) XXX-XXXX
  let formattedNumber = numericInput;

  if (numericInput?.length > 3 && numericInput?.length <= 6) {
    // Format as (XXX) XXX
    formattedNumber = `(${numericInput.slice(0, 3)}) ${numericInput.slice(3)}`;
  } else if (numericInput?.length > 6) {
    // Format as (XXX) XXX-XXXX
    formattedNumber = `(${numericInput.slice(0, 3)}) ${numericInput.slice(
      3,
      6
    )}-${numericInput.slice(6, 14)}`;
  }

  return formattedNumber || "";
};

//manages the remember me functionalities on the login page
export const manageRememberMe = (
  verificationType,
  email,
  phoneDetails,
  rememberDevice,
  country
) => {
  if (verificationType === "email") {
    cookies.set("userEmail", email, { path: "/", maxAge: 7 * 24 * 60 * 60 });
  } else if (verificationType === "phone") {
    cookies.set("userPhone", phoneDetails, {
      path: "/",
      maxAge: 7 * 24 * 60 * 60,
    });
    cookies.set("country", country, {
      path: "/",
      maxAge: 7 * 24 * 60 * 60,
    });
  }
  if (rememberDevice) {
    cookies.set("verificationType", verificationType, {
      path: "/",
      maxAge: 7 * 24 * 60 * 60,
    });

    if (verificationType === "email") {
      cookies.set("email", email, { path: "/", maxAge: 7 * 24 * 60 * 60 });
      cookies.remove("phoneDetails"); // Remove phone details if previously stored
      cookies.remove("country");
    } else if (verificationType === "phone") {
      cookies.set("phoneDetails", phoneDetails, {
        path: "/",
        maxAge: 7 * 24 * 60 * 60,
      });
      cookies.set("country", country, {
        path: "/",
        maxAge: 7 * 24 * 60 * 60,
      });
      cookies.remove("email"); // Remove email if previously stored
    }

    cookies.set("rememberDevice", rememberDevice, {
      path: "/",
      maxAge: 7 * 24 * 60 * 60,
    });
  } else {
    // Clear all related cookies if "Remember this device" is not selected
    cookies.remove("email");
    cookies.remove("phoneDetails");
    cookies.remove("verificationType");
    cookies.remove("rememberDevice");
    cookies.remove("country");
  }
  cookies.set("userType", verificationType, {
    path: "/",
    maxAge: 7 * 24 * 60 * 60,
  });
};

//Validate the email
export const validateEmail = (email, stateUpdate) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}(?:\.[a-zA-Z]{2,})*$/;
  const consecutiveDotsRegex = /\.\./;
  const trimmedEmail = email?.trim();

  const isValid =
    emailRegex.test(trimmedEmail) && !consecutiveDotsRegex.test(trimmedEmail);

  if (!isValid) {
    if (stateUpdate) {
      if (!trimmedEmail.trim()) {
        stateUpdate("Email Address is required.");
      } else {
        stateUpdate("Please enter a valid email address.");
      }
    }
    return false;
  }
  return true;
};

//validate phone number for login page
export const validatePhoneNumber = (phoneNumber, setPhoneErrors) => {
  const isValid = phoneNumber && phoneNumber.length >= 10;
  if (!isValid) {
    if (setPhoneErrors) {
      if (phoneNumber.length == 0) {
        setPhoneErrors("Phone Number is required.");
      } else if (!(phoneNumber.length >= 10 && phoneNumber.length <= 15)) {
        setPhoneErrors("Phone Number should be 10-15 digits long.");
      }
    }
  }
  return isValid;
};

// Countries options and dialcode data list for phone number input
export const countryOptions = countries.all
  .filter((country) => country.countryCallingCodes.length > 0)
  .map((country) => ({
    value: country.alpha2,
    label: `${country.name} (${country.countryCallingCodes[0]})`,
    dialCode: country.countryCallingCodes[0],
    flag: `flag-icon flag-icon-${country.alpha2.toLowerCase()}`,
    name: country.name,
  }));

  // Function to format the timer in MM:SS format
export const formatTime = (timer) => {
  const minutes = Math.floor(timer / 60);
  const seconds = timer % 60;
  return `${String(minutes).padStart(2)}:${String(seconds).padStart(2, "0")}`;
};


// Format date and time for chat with the same format and time preference
export const formatDateTime = (dateString, dateFormat = "MM/DD/YYYY", timeFormat = "12hour") => {
  const date = new Date(dateString);
  const today = new Date();

  // Reset today's date to midnight for easier comparison
  today.setHours(0, 0, 0, 0);

  // Calculate yesterday by subtracting one day from today's midnight time
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);

  // Helper function to format date based on the provided format
  const formatDate = (date, format) => {
    const options = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    };
    switch (format.toUpperCase()) { // Ensure case insensitivity
      case "DD/MM/YYYY":
        return date.toLocaleDateString("en-GB", options);
      case "MM/DD/YYYY":
        return date.toLocaleDateString("en-US", options);
      case "YYYY/MM/DD":
        return date.toISOString().split("T")[0];
      default:
        return date.toLocaleDateString(); // Fallback to default format
    }
  };

  // Helper function to format time based on the 12-hour or 24-hour preference
  const formatTime = (date, format) => {
    return date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: format === "12hour", // Use 12-hour format if specified
    });
  };

  // Determine if the date is today, yesterday, or neither
  if (date >= today) {
    return `${formatTime(date, timeFormat)} Today`;
  } else if (date >= yesterday) {
    return `${formatTime(date, timeFormat)} Yesterday`;
  } else {
    return `${formatTime(date, timeFormat)} ${formatDate(date, dateFormat)}`;
  }
};

// Validate text input fields
export const validateTextInput = (value) => {
  const trimmedValue = value?.trim();
  const startsWithInvalidChar = /^[^a-zA-Z]/.test(trimmedValue);
  const isValid =
    trimmedValue && trimmedValue.length >= 2 && /[a-zA-Z]/.test(trimmedValue);
  //  &&
  // !startsWithInvalidChar;

  return {
    isValid,
    cleanedValue: trimmedValue,
    message: isValid
      ? "Valid input"
      : // : startsWithInvalidChar
      // ? "Field should not start with a number or special character."
      !(trimmedValue?.length >= 2)
      ? "Please enter at least 2 characters."
      : "Please ensure the field contains alphabets.",
  };
};

//function to validate the form for registration page
export const validateForm = (formValues, validateCompany = false) => {
  let tempErrors = {};

  const validateField = (fieldValue, fieldName) => {
    const validation = validateTextInput(fieldValue);
    if (!validation.isValid) {
      if (!validation.cleanedValue) {
        return `${fieldName} is required.`;
      } else if (/^[^a-zA-Z]/.test(validation.cleanedValue)) {
        return "Field should not start with a number or special character.";
      } else {
        return validation.message;
      }
    }
    return null;
  };

  tempErrors.fullName = validateField(formValues.fullName, "Full Name");
  
  if (validateCompany) {
    tempErrors.companyName = validateField(formValues.companyName, "Company Name");
  }

  if (!validateEmail(formValues.email)) {
    tempErrors.email = formValues.email?.trim().length > 0
      ? "Please enter a valid email address."
      : "Email Address is required.";
  }

  const phoneNumber = getPlainPhoneNumber(formValues.phoneNumber)?.trim();
  if (!phoneNumber) {
    tempErrors.phoneNumber = "Phone number is required.";
  } else if (phoneNumber.length < 10) {
    tempErrors.phoneNumber = "PhoneNumber should be 10-15 digits long.";
  }

  return Object.fromEntries(Object.entries(tempErrors).filter(([_, v]) => v));
};
